<template>
  <div class="ren-decoration-cp ren-decoration-cp-product-media" :style="boxStyle">
    <img v-if="imageUrl" :src="imageUrl" alt="" />
    <span v-else>商品主图</span>
    <i v-if="showVideo">视频</i>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, numberValue, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const data = computed(() => previewDataRecord(props.componentData))
const showVideo = computed(() => booleanValue(props.component.props?.showVideo, true))
const imageUrl = computed(() => {
  const images = data.value.images
  const first = Array.isArray(images) ? images[0] : undefined
  return widgetMediaUrl(first ?? data.value.coverImageUrl ?? data.value.imageUrl)
})
const boxStyle = computed(() => {
  const height = numberValue(props.component.props?.height, 0)
  const radius = Number(props.component.style?.radius)
  return {
    minHeight: height > 0 ? `${Math.min(height, 420)}px` : undefined,
    borderRadius: Number.isFinite(radius) && radius >= 0 ? `${radius}px` : undefined
  }
})
</script>

<style scoped>
.ren-decoration-cp-product-media {
  position: relative;
  display: grid;
  place-items: center;
  min-height: 160px;
  overflow: hidden;
  background: var(--ren-theme-background);
  color: var(--ren-theme-muted);
}

.ren-decoration-cp-product-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ren-decoration-cp-product-media i {
  position: absolute;
  right: 12px;
  bottom: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  background: var(--ren-theme-primary);
  color: #fff;
  font-size: 12px;
  font-style: normal;
}
</style>
